import { Injectable } from '@angular/core';
import { HttpClient,HttpRequest,HttpResponse} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class InsightsService {
  private API=environment.apiURL
  constructor(private http:HttpClient) {
   }

  getApiKey(merchantID){
    return this.http.get<any>(this.API+'/merchants/'+merchantID+'/api-key',{observe:'response'})
  }

  generateApiKey(merchantID,request):Observable<any> {
    return this.http.post(this.API+'/merchants/'+merchantID+'/api-key/generate',request,{observe: 'response'})
  }

  getBotlist(merchantID){
    return this.http.get<any>(this.API+'/merchants/'+merchantID+'/bots',{observe:'response'})
  }

  getConversations(botID, date) {
    return this.http.get<any>(`${this.API}/billing/bots/${botID}/conversations?start_date=${date.from}&end_date=${date.to}`);
  }
}
